import { REFRESH_TOKEN_COOKIE } from 'config/cookie';
import moment from 'moment';
import { CookieSetOptions } from 'universal-cookie';
import { cookiesInstance } from './cookiesInstance';

export const set = (value: string, keepMeLogged: boolean) => {
  const expirationsDays = 14;
  const expirationDate = moment().add(expirationsDays, 'days').toDate();
  const nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  const options: CookieSetOptions = { expires: keepMeLogged ? nextYear : expirationDate };
  cookiesInstance.set(REFRESH_TOKEN_COOKIE, value, options);
};

export const get = () => {
  const refreshToken = cookiesInstance.get(REFRESH_TOKEN_COOKIE);
  return refreshToken;
};

export const remove = () => cookiesInstance.remove(REFRESH_TOKEN_COOKIE);
